import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Scopes = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>🔐 Scopes &amp; Permissions</h1>
        <p>
          Les scopes permettent de limiter ce qu'une API Key peut faire.
          Une API Key sans scope explicite a un accès complet (rétro-compat) ;
          dès que vous lui assignez des scopes, elle est restreinte à ceux-ci.
        </p>
      </div>

      <div className="section">
        <h2>Scopes disponibles</h2>
        <table className="params-table">
          <thead><tr><th>Scope</th><th>Permet</th></tr></thead>
          <tbody>
            <tr><td><code>contacts:read</code></td><td>Lister et récupérer les contacts</td></tr>
            <tr><td><code>contacts:write</code></td><td>Créer, mettre à jour et supprimer les contacts</td></tr>
            <tr><td><code>groups:read</code></td><td>Lister et récupérer les groupes</td></tr>
            <tr><td><code>groups:write</code></td><td>Créer/supprimer des groupes, ajouter/retirer des contacts</td></tr>
            <tr><td><code>messages:send</code></td><td>Envoyer des templates WhatsApp</td></tr>
            <tr><td><code>templates:read</code></td><td>Lister et récupérer les templates</td></tr>
            <tr><td><code>templates:write</code></td><td>Créer et soumettre des templates à Meta</td></tr>
            <tr><td><code>campaigns:read</code></td><td>Lister et récupérer les campagnes</td></tr>
            <tr><td><code>campaigns:write</code></td><td>Annuler des campagnes</td></tr>
            <tr><td><code>webhooks:manage</code></td><td>Gérer les webhooks sortants (CRUD)</td></tr>
          </tbody>
        </table>
      </div>

      <div className="section">
        <h2>Erreur 403</h2>
        <p>
          Si une API Key tente d'accéder à une route pour laquelle elle n'a pas le scope requis,
          le serveur répond <strong>HTTP 403</strong> avec :
        </p>
        <CodeBlock language="json" code={`{
  "error": "Cette API key n'a pas le scope requis : contacts:write"
}`} />
        <p>
          Ajoutez le scope manquant à votre API Key (depuis Réglages → Développeurs) puis ré-essayez.
        </p>
      </div>

      <div className="section">
        <h2>Recommandations sécurité</h2>
        <ul>
          <li>
            <strong>Principe du moindre privilège</strong> — donnez à chaque intégration tierce uniquement
            les scopes dont elle a besoin (ex: une intégration "newsletter Mailchimp" qui ne fait
            que lire les contacts → seulement <code>contacts:read</code>).
          </li>
          <li>
            <strong>Une API Key par intégration</strong> — n'utilisez pas la même API Key pour plusieurs outils.
            En cas de fuite, vous pouvez révoquer juste celle-ci sans casser les autres.
          </li>
          <li>
            <strong>Date d'expiration</strong> — fixez une <code>expiresAt</code> sur les keys de test
            (par défaut : pas d'expiration sur les keys de production).
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Scopes;
